import { useState } from "react";
import "./styles.css";
import resultImage from "../../assets/resultImageClouds.svg";
import InfoCards from "../../components/InfoCards/InfoCards";
import countIcn from "../../assets/countIcon.svg";
import wordsIcn from "../../assets/wordsIcon.svg";
import quickSightIcn from "../../assets/quickSightIcon.svg";
import ResultCard from "../../components/ResultCard/ResultCard";
import correct from "../../assets/correct.svg";
import missed from "../../assets/missed.svg";
import extra from "../../assets/extra.svg";
import incorrect from "../../assets/incorrect.svg";
import enSpreadedLetters from "../../assets/en_spreaded_letters.svg";
import hiSpreadedLetters from "../../assets/hi_spreaded_letters.svg";
import AudioPlayer from "../../AudioPlayer";
import DetailedResultCard from "../../components/DetailedResultCard/DetailedResultCard";
import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import correctPercentageIcn from "../../assets/correctPercentageIcn.svg";
import { Button, Box, Typography } from "@mui/material";
import { useTranslationSetup } from "../../utils/useTranslationSetup";
import { SCREENS } from "../../utils/CommonUtils/screenConstants";
import ThankYouScreen from "../ThankYouScreen/ThankYouScreen";

const DemoResultsScreen = ({
  name,
  processedData,
  audioBlobForAudioPlayer,
  setAudioBlobForAudioPlayer = () => {},
  setAssessmentLang,
  setHideSlider,
  setOrfResultStatus,
  setUploadAudioStatus,
  setAudioUploading,
  setSaveClicked,
  setName,
  setActiveScreen,
  setSplash,
}) => {
  const [expandText, setExpandText] = useState(false);
  const { t } = useTranslationSetup();
  const formattedPercentage = processedData?.result?.correct_percentage
    ? (processedData?.result?.correct_percentage * 100).toFixed(2)
    : "0.00";
  const formattedCwpm = processedData?.result?.cwpm
    ? processedData.result.cwpm.toFixed(2)
    : "0.00";
  const [showThankYou, setShowThankYou] = useState(false);

  const handleNavigateToSelectAssessmentLangScreen = () => {
    setActiveScreen(SCREENS.RENDER_ASSESSMENT_LANG_SCREEN);
    setAssessmentLang(null);
    setAudioBlobForAudioPlayer(null);
    setHideSlider(false);
    setOrfResultStatus(null);
    setUploadAudioStatus(null);
    setAudioUploading(false);
    setSaveClicked(false);
  };

  const handleNavigateToInputFieldsScreen = () => {
    setShowThankYou(true);
  };

  const redirectToHomeScreen = () => {
    setShowThankYou(false);
    setSplash(true);
    setName("");
    setAssessmentLang(null);
    setHideSlider(false);
    setOrfResultStatus(null);
    setUploadAudioStatus(null);
    setAudioUploading(false);
    setSaveClicked(false);
  };

  const detailedResult = [
    {
      heading: t("incorrect_words"),
      subHeading: t("incorrect_words_detail"),
      bgColor: "rgba(212, 43, 83, 0.13)",
      innerBorderColor: "#D42B53",
      icon: incorrect,
      words: processedData?.result["incorrect_words"],
    },
    {
      heading: t("correct_words"),
      subHeading: t("correct_words_detail"),
      bgColor: "rgba(126, 182, 107, 0.17)",
      innerBorderColor: "#7EB66B",
      icon: correct,
      words: processedData?.result["correct_words"],
    },
    {
      heading: t("missed_words"),
      subHeading: t("missed_words_detail"),
      bgColor: "rgba(154, 23, 201, 0.07)",
      innerBorderColor: "#9A17C9",
      icon: missed,
      words: processedData?.result["missed_words"],
    },
    {
      heading: t("extra_words"),
      subHeading: t("extra_words_detail"),
      bgColor: "rgba(95, 188, 240, 0.13)",
      innerBorderColor: "#5FBCF0",
      icon: extra,
      words: processedData?.result["extra_words"],
    },
  ];

  if (showThankYou) {
    return <ThankYouScreen onRedirect={redirectToHomeScreen} />;
  }

  return (
    <Box className="demo-result-screen-wrapper">
      <Box className="result-page">
        <Box className="header">
          <Typography className="header-text">{name}</Typography>
        </Box>
        <Box className="demo-result-divider" />
        <Box className="imageContainer">
          <img src={resultImage} alt="Result" className="result-image"/>
        </Box>
        <Box className="result-grid-container">
          <Box className="infoCardsContainer">
            <InfoCards
              icon={countIcn}
              info={t("cwpm")}
              value={`${formattedCwpm}`}
            />
            <Typography className="cwpm-info">
              {t("cwpm_correct_words_per_minute")}
            </Typography>
            <InfoCards
              icon={wordsIcn}
              info={t("words_read_aloud")}
              value={`${processedData?.result?.total_words_read}/${processedData?.result?.total_words}`}
            />
            <InfoCards
              icon={correctPercentageIcn}
              info={t("accuracy")}
              value={`${formattedPercentage}%`}
            />
          </Box>
          <Box className="quicksight-card">
            <Box className="quicksight-card-header">
              {t("quick_sight")}
              <img src={quickSightIcn} alt="Quick Sight" />
            </Box>
            <Box className="quicksight-grid">
              <ResultCard
                heading={t("correct_words")}
                headingColor={"#7EB66B"}
                bgColor={"rgba(126, 182, 107, 0.12)"}
                value={processedData?.result["correct_words"].length}
                image={correct}
              />
              <ResultCard
                heading={t("missed_words")}
                headingColor={"#9A17C8"}
                bgColor={"rgba(154, 23, 200, 0.12)"}
                value={processedData?.result["missed_words"].length}
                image={missed}
              />
              <ResultCard
                heading={t("extra_words")}
                headingColor={"#5FBCF0"}
                bgColor={"rgba(95, 188, 240, 0.12)"}
                value={processedData?.result["extra_words"].length}
                image={extra}
              />
              <ResultCard
                heading={t("incorrect_words")}
                headingColor={"#E70000"}
                bgColor={"rgba(212, 43, 83, 0.12)"}
                value={processedData?.result["incorrect_words"].length}
                image={incorrect}
              />
            </Box>
          </Box>
          <Box className="paragraph-wrapper-card">
            <Box className="paragraph-card">
              <Box className="para-heading">{t("paragraph")}</Box>
              {audioBlobForAudioPlayer && (
                <Box className="audio-player-wrapper">
                  <Box className="audio-player">
                    <AudioPlayer
                      audioBlobForAudioPlayer={audioBlobForAudioPlayer}
                      setAudioBlobForAudioPlayer={setAudioBlobForAudioPlayer}
                      testedAudioElementRef={false}
                    />
                  </Box>
                </Box>
              )}
              <Box
                className="paragraph-para"
                style={{ WebkitLineClamp: !expandText ? 3 : "" }}
                onClick={() => setExpandText(!expandText)}
              >
                {processedData["paragraph"]}
              </Box>
            </Box>
          </Box>
          <Box className="detailed-result-card">
            <Box className="detailed-result-card-heading">
              {t("detailed_result")}
            </Box>
            <Box className="detailed-result-grid">
              {detailedResult.map((res, idx) => {
                return (
                  <DetailedResultCard
                    key={idx}
                    heading={res.heading}
                    subHeading={res.subHeading}
                    bgColor={res.bgColor}
                    icon={res.icon}
                    innerBorderColor={res.innerBorderColor}
                    words={res.words}
                  />
                );
              })}
            </Box>
          </Box>
        </Box>
        <Box className="result-page-btn-wrapper">
          <Button
            className="another-language-button"
            endIcon={<ArrowForwardOutlinedIcon />}
            onClick={handleNavigateToSelectAssessmentLangScreen}
          >
            <img
              src={enSpreadedLetters}
              alt="en-spreaded-letters"
              className="en-spreaded-letters"
            />
            {t("try_another_langauge")}
            <img
              src={hiSpreadedLetters}
              alt="hi-spreaded-letters"
              className="hi-spreaded-letters"
            />
          </Button>
          <Button
            className="new-assessment-button"
            onClick={handleNavigateToInputFieldsScreen}
            startIcon={<KeyboardReturnIcon />}
          >
            {t("new_assessment")}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default DemoResultsScreen;
